import React from "react";
import { Divider } from "@heroui/react";

interface DividerWithTextProps {
  children?: React.ReactNode;
  className?: string;
  orientation?: "horizontal" | "vertical";
}

/**
 * DividerWithText component renders a divider with text between two lines.
 * @param {Object} props The props object.
 * @param {React.ReactNode} props.children The content to display between the dividers.
 * @param {string} [props.className] Additional CSS class names.
 * @param {"horizontal"|"vertical"} [props.orientation="horizontal"] Orientation of the divider.
 * @returns {JSX.Element} The rendered DividerWithText component.
 */
export default function DividerWithText({
  children,
  className,
  orientation = "horizontal",
}: DividerWithTextProps) {
  return (
    <div className="flex items-center py-2">
      <div className="flex-1">
        <Divider className={className} orientation={orientation} />
      </div>
      <span className="mx-2">{children}</span>
      <div className="flex-1">
        <Divider className={className} orientation={orientation} />
      </div>
    </div>
  );
}
